import api from '.';

export const DiplomatObjectEndpoints = {
   ARCHIVE_SETTINGS: ``,
   AUDIT_TRAIL_SETTINGS: ``,
   AUTH_POLICIES: ``,
   BACKUP_SETTINGS: api.backupSettings,
   CONFIG_SETTINGS: ``,
   EMAIL_SERVER_SETTINGS: `${api.emailSettings}`,
   ENCRYPTION_PRODUCT_SETTINGS: ``,
   EXTERNAL_PARTNER: `${api.partners}`,
   INTERNAL_PARTNER: `${api.partners}`,
   FOLDER: ``,
   FTP_ADMIN_SETTINGS: ``,
   FTP_SETTINGS: api.settingsFTP,
   HOLIDAY_CALENDAR: ``,
   IT_SUPPORT_EMAIL_SETTINGS: ``,
   JOB_HISTORY_SETTINGS: api.jobHistorySettings,
   JOB_SETTINGS: ``,
   JOB_SUSPENSION: ``,
   KEY_PAIR: `${api.keys}/pgp/keypair`,
   PUBLIC_KEY: `${api.keys}/pgp/public`,
   SSH_KEY: `${api.keys}/ssh`,
   SSH_PUBLIC_KEY: `${api.keys}/ssh`,
   SSH_HOST_KEY: `${api.keys}/ssh/hostkeys`,
   KEY_SETTINGS: api.keysSettings,
   LOG_FILE_SETTINGS: api.logFileSettings,
   INBOUND_TRANSACTION: `${api.transactions}`,
   OUTBOUND_TRANSACTION: `${api.transactions}`,
   PAGING_SETTINGS: api.pagingSettings,
   PASSWORD_DATA: ``,
   PROXY_SERVER: ``,
   SCHEDULED_REPORT: ``,
   SESSION_DATA: ``,
   SSL_CERTIFICATE: `${api.keys}/ssl`,
   SSL_CLIENT_CERTIFICATE: `${api.keys}/ssl`,
   TIMEOUT_RETRY_SETTINGS: ``,
   USER: ``,
   AS2_SETTINGS: ``,
   SFTP_USER: `${api.sftpUser}`,
   VFS: api.nodedetails,
   VFS_PERMISSION: api.vfspermissions,
   VFS_GROUP: api.vfsgroups,
   SYNCHRONIZATION: api.synchronizations,
};
